var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"review-sheet",staticStyle:{"margin":"0 auto","width":"1200px","margin-top":"20px","margin-bottom":"20px"}},[_c('review-opinion-result',{attrs:{"form":_vm.savedOpinion,"id":_vm.id,"cid":_vm.aid,"base":{
          name: _vm.info.name,
          company: _vm.info.unit,
          reviewers: _vm.info.reviewers
        },"zs":_vm.zs}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }